<template>
  <div class="container z-flex">
    <div class="main-con z-flex z-flex-col">
      <div class="main-box" ref="mainBox">
        <div class="msg-list">
          <div
            class="item"
            v-for="(item, index) in msgList"
          >
            <div class="msg msg-my z-flex">
              <el-avatar
                class="avatar"
                icon="el-icon-user-solid"
                shape="square"
                :src="avatar"
              ></el-avatar>
              <div class="text" v-html="item.myMsg"></div>
            </div>
            <div class="msg msg-robot z-flex">
              <el-avatar
                class="avatar"
                icon="el-icon-s-opportunity"
                shape="square"
              ></el-avatar>
              <div class="text">
                <mavon-editor
                        class="md"
                        :value="item.robotMsg"
                        :subfield="false"
                        :defaultOpen="'preview'"
                        :toolbarsFlag="false"
                        :editable="false"
                        :scrollStyle="true"
                        :code="true"
                        :ishljs="true"
                ></mavon-editor>
              </div>
              <div class="btn-group z-flex">
                <el-button class="btn btn-copy" type="success" size="mini" icon="el-icon-download" @click="downImage(item)">下载图片</el-button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="msg-default z-flex z-flex-col z-flex-center"
          v-if="msgList.length == 0"
        >
          <!-- <i class="logo-icon el-icon-s-promotion"></i> -->
          <img class="logo-icon" src="../assets/images/logo.png" />
          <div class="logo">AI摄影秘书</div>
          <div class="slogan">
            嘿，主人，您好！我是AI摄影秘书，让我开始为您提供摄影与其他服务吧！
          </div>
        </div>
      </div>
    </div>
    <div class="aside-r">
      <div class="aside-r-top">
        <div class="upload-box">
          <el-upload
            class="upload"
            drag
            action=""
            :accept="upAccept"
            :auto-upload="true"
            :before-upload="handleBeforeUpload"
            :http-request="handleHttpRequestOss"
            :show-file-list="false"
          >
            <div class="img-wrap" v-if="fileList[0]">
              <el-image class="img" fit="cover" :src="fileList[0]" />
            </div>
            <div
              class="upload-action-con z-flex z-flex-col z-flex-center"
              v-else
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或<em>点击选择图片</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">请上传 jpg、png格式图片，长宽不超过2000*2000像素，图片大小不超过10M</div>
          </el-upload>
          <div v-if="!isLogin" @click="showLogin" class="login-mask"></div>
        </div>
        <div class="quick-box z-flex z-flex-between">
          <div
            :class="[
              'item z-flex z-flex-center',
              activeQuickItem === index ? 'active' : '',
            ]"
            v-for="(item, index) in quickList"
            :key="index"
            @click="quickClick(item, index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="custom-box" v-show="false">
          <div class="hd z-flex"><i class="el-icon-edit-outline"></i>输入要替换的背景内容</div>
          <el-input
            class="input"
            v-model="input"
            placeholder="输入要替换的背景内容"
          >
          </el-input>
        </div>
      </div>
      <el-button
        class="btn-send"
        type="primary"
        icon="el-icon-s-promotion"
        :loading="sendLoading"
        @click="send"
        >发送</el-button>
    </div>
  </div>
</template>

<script>
  import chatSide from '@/components/chatSide'
  import {mapState} from "vuex";
export default {
  components: {
    chatSide
  },
  data() {
    return {
      isLogin: false,
      writing: false,
      upAccept: "image/jpeg,image/gif,image/png",
      avatar: "",
      input: "",
      imageURL: "",
      imgkey: "",
      groupItem: {
        groupId: 6,
      },
      msgList: [],
      activeChat: 0,
      quickList: [
        //快速选择
        "图片ACR增强",
        "图片智能抠图",
        "黑白图片上色",
        // "去除图片文字",
      ],
      activeQuickItem: -1,
      fileList: [],
      sendLoading:false,
      customKeywords:'',
    };
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  watch:{
    "vuex_user": {
      immediate: true,
      handler(newVal, oldVal) {
        this.isLogin = this.$myFun.isLogin();
      },
    },
  },
  mounted() {
    this.getMsgList();
  },
  created() {},
  methods: {
    //当前会话数据
    onActiveChat(res){
      this.activeChat = res.activeChat;
      this.groupItem = res.groupItem;
      this.getMsgList();
    },
    //获取聊天明细
    getMsgList() {
      if (this.groupItem == null) {
        return;
      }
      this.$axios.api.getMsgList({group_id: this.groupItem.groupId}, (res) => {
        if (res.errno == 0) {
          this.msgList = res.data.list;
          this.handleScrollBottom();
        }
      });
    },
    // mini发送
    miniSend(txt) {
      this.input = txt;
      this.send();
    },
    //发送
    send() {
      if (!this.$myFun.isLogin()) {
        return this.$parent.showLogin();
      }
      if (this.fileList.length <= 0) {
        return this.$message.error("请先上传图片");
      }
      if (this.input.trim() === "") {
        return this.$message.error("请选择您的创作需求");
      }
      const loading = this.$loading({
        target:'.main-con',
        background:'rgba(0,0,0,.6)',
      });
      this.sendLoading = true;
      let type_arr = ['scale', 'segmentation', 'colorization'];
      let that = this;
      this.$axios.api.request(
        {
          url: "/api.php/chat/buildImage",
          method: "POST",
          data: {
            token: this.$cookies.get("token"),
            type: type_arr[this.activeQuickItem],
            img_url: this.imageURL,
            group_id: this.groupItem.groupId,
          },
        },
        (res) => {
          this.sendLoading = false;
          loading.close();
          if (res.errno == 0) {
            let msgItem = {
              myMsg: '<p>' + that.input + '</p>',
              robotMsg: '<p><img src="' + res.data.url + '" /></p>',
            };
            that.msgList.push(msgItem);
            that.handleScrollBottom();
          }else{
            this.$message.error(res.message);
          }
        }
      );
    },
    showLogin() {
      this.$parent.showLogin();
    },
    // 图片下载
    downImage(item) {
      var matchReg = /<img.*?(?:>|\/>)/gi;  // 匹配图片中的img标签
      var arr2 = item.robotMsg.match(matchReg);  //拿到标签中所有的img
      var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src
      if (arr2 != null) {
        for (var i = 0; i < arr2.length; i++) {
          var src = arr2[i].match(srcReg);
          let a = document.createElement("a");
          a.style.display = 'none';
          a.href = src[1];
          a.target = "_blank";
          let filename = a.href.substring(a.href.lastIndexOf("/") + 1);
          a.setAttribute('download', filename);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
      console.log(item)
    },
    Keydown(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation(); //Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.send();
      }
    },
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        this.$refs.mainBox.scrollTo({
          top: this.$refs.mainBox.scrollHeight,
          behavior: "smooth",
        });
      });
    },
    //快捷选项
    quickClick(item, index) {
      this.activeQuickItem = index;
      this.input = item;
    },
    /**
     * 上传之前的校验
     * @param file
     * @returns {boolean|boolean}
     */
    handleBeforeUpload(file) {
      this.upAccept = this.upAccept.toLowerCase();
      let isImage = this.upAccept.indexOf(file.type.toLowerCase()) >= 0;
      let isSize = file.size / 1024 / 1024 < 10;
      if (this.upAccept == "" || this.upAccept == "*") {
        isImage = true;
      }
      if (!isImage) {
        this.$message.error("请上传指定的图片格式[" + this.upAccept + "]!");
      } else if (!isSize) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isImage && isSize;
    },
    /**
     * 上传图片
     * @param opt
     */
    handleHttpRequestOss(opt) {
      const loading = this.$loading({
        target:'.upload-box',
        background:'rgba(0,0,0,.6)',
      });
      this.$myFun.getFileMd5(opt.file, (fileMd5) => {
        //上传到OSS
        opt.file.md5 = fileMd5;
        this.uploadOss(opt.file, (file) => {
          loading.close();
          this.imageURL = file.ossurl;
          this.fileList = [file.ossurl];
        })
      });
    },
    //阿里云直传
    uploadOss(file, callback){
      let fileName = file.name;
      this.$axios.api.aliossParams({name: fileName, md5: file.md5}, (resa) => {
        if (resa.code == 200) {
          //阿里云前端直传
          var patt = /^\/\//;
          resa.data.host = (patt.test(resa.data.host) ? 'https:' : '') + resa.data.host;
          var ossform = new FormData();
          ossform.append("name", fileName);
          ossform.append("key", resa.data.key);
          ossform.append("policy", resa.data.policy);
          ossform.append("OSSAccessKeyId", resa.data.OSSAccessKeyId);
          ossform.append("success_action_status", resa.data.success_action_status);
          ossform.append("signature", resa.data.signature);
          ossform.append("callback", resa.data.callback);
          ossform.append("host", resa.data.host);
          ossform.append("file", file, fileName);
          this.$axios.post(resa.data.host, ossform, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(res => {
            if (res.status == 200) {  //上传成功
              file.ossurl = resa.data.host + "/" + resa.data.key;
              callback(file);
              // this.$message.success("上传成功!")
            } else {
              this.$message.error("上传失败，请重新尝试!");
            }
          }).catch(error => {
            console.log("alioss错误: ", error);
          })
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-r {
  position: relative;
  .aside-r-top {
    width: 100%;
    height: calc(100% - 60px);
    overflow-y: auto;
  }
  .upload-box {
    position: relative;
    ::v-deep .upload {
      width: 100%;
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          background: $colorBgLight;
          width: 100%;
          height: 180px;
          border: $borderDashed;
          &:hover {
            border-color: $colorMain;
          }
          .el-upload__text {
            color: #eee;
          }
          .el-icon-upload {
            color: $colorMain;
          }
        }
      }
      .el-upload__tip{
        color: $colorRed;
      }
    }
    .img-wrap {
      position: relative;
      width: 100%;
      height: 100%;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .login-mask{
      width: 100%;
      height:180px;
      position: absolute;
      left: 0;
      top: 0;
      cursor: pointer;
    }
  }
  .quick-box {
    align-items: stretch;
    margin-top: 20px;
    .item {
      padding: 10px;
      border: $border;
      box-sizing: border-box;
      border-radius: 4px;
      width: calc(50% - 5px);
      cursor: pointer;
      margin-bottom: 10px;
      font-size: 14px;
      text-align: justify;
      &:hover {
        border-color: $colorMain;
      }
      &.active {
        border-color: $colorMain;
        color: $colorMain;
      }
    }
  }
  .input-box {
    margin-top: 10px;
    ::v-deep .el-textarea__inner {
      background: $colorBgLight;
      border: $border;
      color: #fff;
      &:focus {
        border-color: $colorMain;
      }
    }
  }
  .custom-box{
    margin-top: 20px;
    .hd{
      font-size:15px;
      margin-bottom: 10px;
      i{
        font-size: 16px;
        margin-right: 5px;
      }
    }
    ::v-deep .el-input__inner {
      background: $colorBgLight;
      border: $border;
      color: #fff;
      &:focus {
        border-color: $colorMain;
      }
    }
    .tips{
      font-size: 12px;
      margin-top: 10px;
      color: $colorRed;
    }
  }
  .btn-send {
    width: calc(100% - 40px);
    position: absolute;
    left: 20px;
    bottom: 20px;
  }
}
</style>
